subscription TravelAuthorizationMovementReportStatus($id: UUID!) {
  travelAuthorizationMovementReportStatus(id: $id) {
    document {
      id
    }
    status
  }
}
